// extracted by mini-css-extract-plugin
module.exports = {"backdrop":"Modal_backdrop__2SbcP","modal":"Modal_modal__3Sw5R","slide-down":"Modal_slide-down__1XKzt"};